'use strict';

import React from 'react';
import accounting from 'accounting';

import i18n from 'ofs/i18n';
var gettext = i18n.gettext;
import RatesGuide from 'ofs/react/components/rates-guide';


//       <tr>
//         <th scope="row">{% trans "Length of stay" %}</th>
//         <td>{{ stay_length }}</td>
//       </tr>
//       <tr class="total">
//         <th scope="row">{% trans "Standard Rate" %}</th>
//         <td>{% currency total unit.currency quote=user.currency decimals=0 lang=LANGUAGE_CODE %}</td>
//       </tr>
//       {% if flexible_rate %}
//       <tr class="flexible-rate">
//         <th scope="row">{% trans "Flexible Rate" %}</th>
//         <td>{% currency flexible_rate unit.currency quote=user.currency decimals=0 lang=LANGUAGE_CODE %}</td>
//       </tr>
//       {% endif %}
//     </table>
//   {% else %}
//     <p class="error">
//       {{ error_msg }}
//     </p>
//   {% endif %}
// {% endif %}

// discount: 0
// end_date: "2015-04-09T11:00:00"
// flexible_rate: "4232.75"
// nightly_rate: "550.00"
// page: "summary"
// start_date: "2015-04-03T16:00:00"
// stay_length: 6
// total: "3807.75"

var messages = {
  PRICE_PER_NIGHT: gettext("Price per night"),
  LENGTH_OF_STAY: gettext("Length of stay"),
  STANDARD_RATE: gettext("Standard rate"),
  FLEXIBLE_RATE: gettext("Flexible rate")
}


const BookingQuote = React.createClass({
  render() {
    var {data} = this.props;

    var moneyOptions = {
      symbol: data.currency,
      decimal : i18n.get_format('DECIMAL_SEPARATOR'),
      thousand: i18n.get_format('THOUSAND_SEPARATOR'),
      precision : 0
    };

    return (
      <div className="ofs-BookingQuote">
        <table className="ofs-BookingQuote__Table">
          <tr className="ofs-BookingQuote__Row">
            <th className="ofs-BookingQuote__Label" scope="row">{messages.PRICE_PER_NIGHT}</th>
            {data.discounted_nightly_rate ?
              <td className="ofs-BookingQuote__Value"><s>{accounting.formatMoney(data.nightly_rate, moneyOptions)}</s><br />
              {accounting.formatMoney(data.discounted_nightly_rate, moneyOptions)}</td>
              : <td className="ofs-BookingQuote__Value">{accounting.formatMoney(data.nightly_rate, moneyOptions)}</td>
            }
          </tr>
          <tr className="ofs-BookingQuote__Row">
            <th className="ofs-BookingQuote__Label" scope="row">{messages.LENGTH_OF_STAY}</th>
            <td className="ofs-BookingQuote__Value">{data.stay_length}</td>
          </tr>
          <tr className="ofs-BookingQuote__Row ofs-BookingQuote__Row--total">
            <th className="ofs-BookingQuote__Label ofs-BookingQuote__Label--total" scope="row">{messages.STANDARD_RATE}</th>
            <td className="ofs-BookingQuote__Value ofs-BookingQuote__Value--total">{accounting.formatMoney(data.total, moneyOptions)}</td>
          </tr>
          {data.flexible_rate ?
            <tr className="ofs-BookingQuote__Row ofs-BookingQuote__Row--flexibleRateTotal">
              <th className="ofs-BookingQuote__Label ofs-BookingQuote__Label--flexibleRateTotal" scope="row">{messages.FLEXIBLE_RATE}< /th>
              <td className="ofs-BookingQuote__Value ofs-BookingQuote__Value--flexibleRateTotal">{accounting.formatMoney(data.flexible_rate, moneyOptions)}</td>
            </tr>
            : null}
        </table>

        {data.flexible_rate ? <RatesGuide /> : null}
      </div>
    );
  }
});

export default BookingQuote;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/legacy/property/default/views/BookingQuote.jsx
 **/